import { CheckOutlined } from "@mui/icons-material";
import CopyText from "components/copyText";
import { FilteredTableColumn } from "components/FilteredTable/types";
import { IAtp } from "./types";


const columns: FilteredTableColumn[] = [
  {
    title: 'ID',
    items: [
      {
        title: 'ID',
        style: {
          whiteSpace: "nowrap"
        },
        render: (row: IAtp) => (
          <CopyText text={row.id}>{row.id}</CopyText>
        )
      }
    ],
    width: 1
  },
  {
    title: 'Назва',
    items: [
      {
        title: 'Назва',
        render: (row: IAtp) => row.name
      }
    ]
  },
  {
    title: 'Куратор',
    items: [
      {
        title: 'Куратор',
        render: (row: IAtp) => `${row.owner.last_name} ${row.owner.first_name} ${row.owner.middle_name} `
      }
    ]
  },
  {
    title: 'Перезмінка',
    items: [
      {
        title: 'Перезмінка',
        render: (row: IAtp) => row.replacement_time
      }
    ]
  },
  {
    title: '1-й рівень',
    items: [
      {
        title: '1-й рівень',
        render: (row: IAtp) => row.driver_request_settings.is_level_1 ? <CheckOutlined color="success" fontSize="small" /> : null
      }
    ]
  },
  {
    title: 'Пошук водіїв',
    items: [
      {
        title: 'Пошук водіїв',
        render: (row: IAtp) => row.driver_request_settings.is_need_drivers ? <CheckOutlined color="success" fontSize="small" /> : null
      }
    ]
  },
];

export default columns;